/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthConfigurationsResponse } from '../../models/auth-configurations-response';

export interface TenantAuthConfigurationsGet$Params {
  'Active-Tenant-Identifier': string;
  authType?: 'auth0' | 'cognito';
  status?: Array<'STARTED' | 'COMPLETED'>;
}

export function tenantAuthConfigurationsGet(http: HttpClient, rootUrl: string, params: TenantAuthConfigurationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthConfigurationsResponse>> {
  const rb = new RequestBuilder(rootUrl, tenantAuthConfigurationsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('authType', params.authType, {});
    rb.query('status', params.status, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthConfigurationsResponse>;
    })
  );
}

tenantAuthConfigurationsGet.PATH = '/auth-configurations';
